import Highcharts from 'highcharts'
import ModuleMap from 'highcharts/modules/map'
import ModuleDrilldown from 'highcharts/modules/drilldown'
import ModuleExport from 'highcharts/modules/exporting'
import ModuleExportData from 'highcharts/modules/export-data'
import ModuleAccessibility from 'highcharts/modules/accessibility'

typeof ModuleMap === 'function' && ModuleMap(Highcharts) // eslint-disable-line no-unused-expressions, new-cap
typeof ModuleDrilldown === 'function' && ModuleDrilldown(Highcharts) // eslint-disable-line no-unused-expressions, new-cap
typeof ModuleExport === 'function' && ModuleExport(Highcharts) // eslint-disable-line no-unused-expressions, new-cap
typeof ModuleExportData === 'function' && ModuleExportData(Highcharts) // eslint-disable-line no-unused-expressions, new-cap
typeof ModuleAccessibility === 'function' && ModuleAccessibility(Highcharts) // eslint-disable-line no-unused-expressions, new-cap

import map from '@highcharts/map-collection/countries/us/us-all.topo.json'
import mapAK from '@highcharts/map-collection/countries/us/us-ak-all.topo.json'
import mapAL from '@highcharts/map-collection/countries/us/us-al-all.topo.json'
import mapAR from '@highcharts/map-collection/countries/us/us-ar-all.topo.json'
import mapAZ from '@highcharts/map-collection/countries/us/us-az-all.topo.json'
import mapCA from '@highcharts/map-collection/countries/us/us-ca-all.topo.json'
import mapCO from '@highcharts/map-collection/countries/us/us-co-all.topo.json'
import mapCT from '@highcharts/map-collection/countries/us/us-ct-all.topo.json'
import mapDC from '@highcharts/map-collection/countries/us/us-dc-all.topo.json'
import mapDE from '@highcharts/map-collection/countries/us/us-de-all.topo.json'
import mapFL from '@highcharts/map-collection/countries/us/us-fl-all.topo.json'
import mapGA from '@highcharts/map-collection/countries/us/us-ga-all.topo.json'
import mapHI from '@highcharts/map-collection/countries/us/us-hi-all.topo.json'
import mapIA from '@highcharts/map-collection/countries/us/us-ia-all.topo.json'
import mapID from '@highcharts/map-collection/countries/us/us-id-all.topo.json'
import mapIL from '@highcharts/map-collection/countries/us/us-il-all.topo.json'
import mapIN from '@highcharts/map-collection/countries/us/us-in-all.topo.json'
import mapKS from '@highcharts/map-collection/countries/us/us-ks-all.topo.json'
import mapKY from '@highcharts/map-collection/countries/us/us-ky-all.topo.json'
import mapLA from '@highcharts/map-collection/countries/us/us-la-all.topo.json'
import mapMA from '@highcharts/map-collection/countries/us/us-ma-all.topo.json'
import mapMD from '@highcharts/map-collection/countries/us/us-md-all.topo.json'
import mapME from '@highcharts/map-collection/countries/us/us-me-all.topo.json'
import mapMI from '@highcharts/map-collection/countries/us/us-mi-all.topo.json'
import mapMN from '@highcharts/map-collection/countries/us/us-mn-all.topo.json'
import mapMO from '@highcharts/map-collection/countries/us/us-mo-all.topo.json'
import mapMS from '@highcharts/map-collection/countries/us/us-ms-all.topo.json'
import mapMT from '@highcharts/map-collection/countries/us/us-mt-all.topo.json'
import mapNC from '@highcharts/map-collection/countries/us/us-nc-all.topo.json'
import mapND from '@highcharts/map-collection/countries/us/us-nd-all.topo.json'
import mapNE from '@highcharts/map-collection/countries/us/us-ne-all.topo.json'
import mapNH from '@highcharts/map-collection/countries/us/us-nh-all.topo.json'
import mapNJ from '@highcharts/map-collection/countries/us/us-nj-all.topo.json'
import mapNM from '@highcharts/map-collection/countries/us/us-nm-all.topo.json'
import mapNV from '@highcharts/map-collection/countries/us/us-nv-all.topo.json'
import mapNY from '@highcharts/map-collection/countries/us/us-ny-all.topo.json'
import mapOH from '@highcharts/map-collection/countries/us/us-oh-all.topo.json'
import mapOK from '@highcharts/map-collection/countries/us/us-ok-all.topo.json'
import mapOR from '@highcharts/map-collection/countries/us/us-or-all.topo.json'
import mapPA from '@highcharts/map-collection/countries/us/us-pa-all.topo.json'
import mapRI from '@highcharts/map-collection/countries/us/us-ri-all.topo.json'
import mapSC from '@highcharts/map-collection/countries/us/us-sc-all.topo.json'
import mapSD from '@highcharts/map-collection/countries/us/us-sd-all.topo.json'
import mapTN from '@highcharts/map-collection/countries/us/us-tn-all.topo.json'
import mapTX from '@highcharts/map-collection/countries/us/us-tx-all.topo.json'
import mapUT from '@highcharts/map-collection/countries/us/us-ut-all.topo.json'
import mapVA from '@highcharts/map-collection/countries/us/us-va-all.topo.json'
import mapVT from '@highcharts/map-collection/countries/us/us-vt-all.topo.json'
import mapWA from '@highcharts/map-collection/countries/us/us-wa-all.topo.json'
import mapWI from '@highcharts/map-collection/countries/us/us-wi-all.topo.json'
import mapWV from '@highcharts/map-collection/countries/us/us-wv-all.topo.json'
import mapWY from '@highcharts/map-collection/countries/us/us-wy-all.topo.json'

const MAPS = {
  AK: mapAK,
  AL: mapAL,
  AR: mapAR,
  AZ: mapAZ,
  CA: mapCA,
  CO: mapCO,
  CT: mapCT,
  DC: mapDC,
  DE: mapDE,
  FL: mapFL,
  GA: mapGA,
  HI: mapHI,
  IA: mapIA,
  ID: mapID,
  IL: mapIL,
  IN: mapIN,
  KS: mapKS,
  KY: mapKY,
  LA: mapLA,
  MA: mapMA,
  MD: mapMD,
  ME: mapME,
  MI: mapMI,
  MN: mapMN,
  MO: mapMO,
  MS: mapMS,
  MT: mapMT,
  NC: mapNC,
  ND: mapND,
  NE: mapNE,
  NH: mapNH,
  NJ: mapNJ,
  NM: mapNM,
  NV: mapNV,
  NY: mapNY,
  OH: mapOH,
  OK: mapOK,
  OR: mapOR,
  PA: mapPA,
  RI: mapRI,
  SC: mapSC,
  SD: mapSD,
  TN: mapTN,
  TX: mapTX,
  UT: mapUT,
  VA: mapVA,
  VT: mapVT,
  WA: mapWA,
  WI: mapWI,
  WV: mapWV,
  WY: mapWY,
}

const EXPORT_CONFIG = {
  chartOptions: {
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
        },
      },
    },
  },
  fallbackToExportServer: false,
}

const Chart = {
  mounted() {
    const config = JSON.parse(this.el.getAttribute('data-chart'))
    const exportConfig = config.exporting || {}

    this.chart = Highcharts.chart(`${this.el.id}_chart`, {
      ...config,
      exporting: { ...EXPORT_CONFIG, ...exportConfig },
      credits: { enabled: false },
    })
  },

  updated() {
    const config = JSON.parse(this.el.getAttribute('data-chart'))

    this.chart.update(config)
  },

  destroyed() {
    this.chart.destroy()
  },
}

const ChartMap = {
  mounted() {
    const config = JSON.parse(this.el.getAttribute('data-chart'))
    const exportConfig = config.exporting || {}
    const chartConfig = config.chart || {}

    this.chart = Highcharts.mapChart(`${this.el.id}_chart`, {
      ...config,
      exporting: { ...EXPORT_CONFIG, ...exportConfig },
      credits: { enabled: false },
      chart: {
        ...chartConfig,
        map,
      },
    })
  },

  updated() {
    const config = JSON.parse(this.el.getAttribute('data-chart'))

    this.chart.update(config)
  },

  destroyed() {
    this.chart.destroy()
  },
}

const ChartMapDrilldown = {
  mounted() {
    const config = JSON.parse(this.el.getAttribute('data-chart'))
    const exportConfig = config.exporting || {}
    const chartConfig = config.chart || {}
    const mapView = map.objects.default['hc-recommended-mapview'];

    this.chart = Highcharts.mapChart(`${this.el.id}_chart`, {
      ...config,
      exporting: { ...EXPORT_CONFIG, ...exportConfig },
      credits: { enabled: false },
      chart: {
        ...chartConfig,
        events: {
          drilldown: this.drilldown.bind(this),
          drillup: this.drillup.bind(this),
        },
        map,
      },
      mapView,
      drilldown: {
        activeDataLabelStyle: {
          color: '#FFFFFF',
          textDecoration: 'none',
          textOutline: '1px #000000',
        },
        breadcrumbs: {
          floating: true,
        },
        drillUpButton: {
          relativeTo: 'spacingBox',
          position: {
            x: 0,
            y: 60,
          },
        },
      },
    })
  },

  // eslint-disable-next-line complexity
  drilldown(e) {
    const hook = e.point.series.userOptions?.custom?.hook

    if (hook) {
      const payload = { map: hook.eventMap, point: e.point.options, properties: e.point.properties }

      this.pushEventTo(hook.target, hook.event, payload, ({ data, view }, _ref) => {
        this.chart.mapView.update(
          Highcharts.merge(
            {
              insets: undefined, // eslint-disable-line no-undefined
              padding: 0,
            },
            MAPS[view].objects.default['hc-recommended-mapview'],
          ),
        );

        this.chart.addSeriesAsDrilldown(e.point, {
          name: e.point.name,
          mapData: MAPS[view],
          joinBy: ['fips', 'fips'],
          data,
          dataLabels: {
            enabled: true,
            format: '{point.name}',
          },
        });
      })
    }
  },

  drillup(e) {
    e.target.mapView.update(
      Highcharts.merge(
        { insets: undefined }, // eslint-disable-line no-undefined
        map.objects.default['hc-recommended-mapview'],
      ),
      false,
    );
  },

  destroyed() {
    this.chart.destroy()
  },
}

export { Chart, ChartMap, ChartMapDrilldown }
